module.exports = __webpack_public_path__ + "static/media/10.4604ce10.mp3";